(function () {
  function formatDate(date) {
    var weekdays = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
    var months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
    return weekdays[date.getDay()] + ' ' + date.getDate() + '. ' + months[date.getMonth()];
  }
  function renderShippingDate() {
    var date = new Date();
    date.setDate(date.getDate() + 2);
    var label = formatDate(date);
    document.querySelectorAll('[data-hh-bygklem-date]').forEach(function (node) {
      node.textContent = label;
      node.setAttribute('data-hh-bygklem-rendered', 'true');
    });
  }
  document.addEventListener('DOMContentLoaded', renderShippingDate);
  document.addEventListener('shopify:section:load', renderShippingDate);
  document.addEventListener('shopify:section:select', renderShippingDate);
  document.addEventListener('shopify:section:deselect', renderShippingDate);
  document.addEventListener('variant:change', renderShippingDate);
  document.addEventListener('product:variant-change', renderShippingDate);
  document.addEventListener('change', function (event) {
    var name = event.target && event.target.name;
    if (name === 'id' || name === 'options[]') window.setTimeout(renderShippingDate, 0);
  });
  var observer = new MutationObserver(function () {
    var node = document.querySelector('[data-hh-bygklem-date]');
    if (node && (!node.getAttribute('data-hh-bygklem-rendered') || /Beregner/i.test(node.textContent))) renderShippingDate();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  renderShippingDate();
})();
